import {dig} from "lib/ext/object";
import useAppContext from "lib/hooks/use-app-context";
import logo from "app/assets/images/logo.png";

export default function Navbar() {
  const {app: {organization}, user} = useAppContext();

  return (
    <div className="bg-navbar navbar-default">
      <div className="container">
        <div className="flex items-center justify-between">
          <a className="inline-block" href="/">
            <img alt="Logo" src={dig(organization, "logo") || logo} />
          </a>
          {user && (
            <div className="flex items-center gap-2">
              <a className="btn btn-nav btn-xs" href="/sessions/logout">
                Logout
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
